export default __webpack_public_path__ + "static/media/rectangles-no-4.9206a5c2.ogg";